import React from "react";

/**
 * The score cards (Symptoms, Stool consistency, Bowel comfort, Fibre and
 * Hydration adherence). Clicking a card selects its Daily Log tab, and for
 * fibre or water the Nutrition measure too.
 *
 * @param {Object} props
 * @param {Array<Object>} props.cards - buildView().cards.
 * @param {(card: { tab: string, nut?: string }) => void} props.onPick
 */
const ScoreCards = ({ cards, onPick }) => (
  <div className="grid gap-[12px]" style={{ gridTemplateColumns: `repeat(${cards.length},minmax(0,1fr))` }}>
    {cards.map((c) => (
      <button
        key={c.id}
        type="button"
        onClick={() => onPick(c)}
        aria-pressed={c.active}
        className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F26A1F] flex flex-col gap-[6px] text-left cursor-pointer bg-white border border-[#ECECEC] hover:border-[#D9CFC7] rounded-[12px] px-[16px] py-[14px] text-[#1f1f1f] min-w-0 transition-shadow duration-200"
        style={{ boxShadow: c.active ? `0 0 0 2px ${c.color}` : "none" }}
      >
        <span className="flex items-center gap-[7px] text-[13px] font-bold text-[#3a3a3a] whitespace-nowrap">
          <span className="w-[8px] h-[8px] rounded-[4px] flex-none" style={{ background: c.color }} />
          {c.name}
        </span>
        <span className="flex items-baseline gap-[5px]">
          <span className="text-[26px] font-bold tracking-[-0.02em] leading-[1.1] tabular-nums">{c.value}</span>
          <span className="text-[12px] text-[#8a8a8a]">{c.unit}</span>
        </span>
        <span className="flex justify-between items-baseline gap-[8px] min-w-0">
          <span className="text-[12px] font-semibold truncate" style={{ color: c.dfg }} title={c.delta}>
            {c.delta}
          </span>
          <span className="text-[12px] text-[#6b6b6b] whitespace-nowrap">{c.ptsTxt}</span>
        </span>
      </button>
    ))}
  </div>
);

export default ScoreCards;
